import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from '../fetcher/fetcher.service';
import { GetUsersResponsePayload, GetUsersByParamsResponsePayload } from '@cpak/adp-cpak-users-service-models';
import { FetcherParams } from '../fetcher/fetcher.types';
import { UpdateUserRequestPayload, UpdateUserResponsePayload } from '@cpak/adp-cpak-users-service-models';
import {
  CreateUserActivityRequestPayload,
  CreateUserActivityResponsePayload,
} from '@cpak/adp-cpak-users-service-models';

export interface GetUserRequestQueryParams {
  territoryIds?: string[];
  countryIds?: string | string[];
  offset?: number;
  limit?: number;
  sort?: string;
  sortOrder?: string;
  query?: string;
  role?: string;
  unassigned?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  static readonly BIG_LIMIT = 1000;

  constructor(private fetcher: FetcherService) {}

  public getUsers(params: GetUserRequestQueryParams): Observable<GetUsersByParamsResponsePayload | null> {
    if (params.territoryIds?.length) params.countryIds = [];
    return this.fetcher.get(`/api/users`, params as FetcherParams);
  }

  public getUsersByRoles(roles: string[], countryIds: string[]): Observable<GetUsersResponsePayload | null> {
    return this.fetcher.get(`/api/users`, {
      roles,
      countryIds,
      limit: UserApiService.BIG_LIMIT,
    });
  }

  public getUsersByCustomParams(params: {
    [key: string]: string | string[] | number;
  }): Observable<GetUsersResponsePayload | null> {
    return this.fetcher.get(`/api/users`, params);
  }

  public updateUser(payload: UpdateUserRequestPayload): Observable<UpdateUserResponsePayload | null> {
    return this.fetcher.patch<UpdateUserResponsePayload>(`/api/users/${payload.id}`, payload.data);
  }

  public createUserActivity(
    payload: CreateUserActivityRequestPayload
  ): Observable<CreateUserActivityResponsePayload | null> {
    return this.fetcher.post<CreateUserActivityResponsePayload>(`/api/userActivity`, payload.data);
  }
}
